module.exports = __webpack_public_path__ + "media/images/icons/stairs-20940bac8176cce37b236d80e87ceca1.svg";